import React, { useState } from 'react';
import { Pencil, Trash2, ArrowLeft, ArrowRight } from 'lucide-react';
import styles from './VillageTab.module.scss';

import Flag from '../../../utils/Flags/Flags';
import RichTextEditor from '../../../utils/RichTextEditor/RichTextEditor';

import Modal from '../Modal/Modal';


function VillageTab({ village, parcours, onCreateParcours, onParcoursSelect, onUpdateParcours, onDeleteParcours, onTabChange, onToggleParcoursActive }) {
    const [parcoursName, setParcoursName] = useState('');
    // const [selectedParcours, setSelectedParcours] = useState(null);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [parcoursLang, setParcoursLang] = useState('fr'); // par défaut: français
    const [editLang, setEditLang] = useState('fr'); // pour l'édition
    const [editName, setEditName] = useState('');
    const [editIntro, setEditIntro] = useState('');
    const [editOutro, setEditOutro] = useState('');

    if (!village) {
        return <p className={styles.infoMessage}>Veuillez d'abord sélectionner un village.</p>;
    }

    const handleCreateParcours = (e) => {
        e.preventDefault();
        if (!parcoursName.trim()) return;

        const newParcours = onCreateParcours(village.id, parcoursName, parcoursLang);
        if (newParcours) {
            // setSelectedParcours(newParcours);
            setParcoursName('');
        }
    };

    const handleParcoursClick = (parcours) => {
        // setSelectedParcours(parcours);
        onParcoursSelect(parcours);
    };

    const openEditModal = (parcours, e) => {
        e.stopPropagation();
        setCurrentItem(parcours);
        setEditName(parcours.nom);
        setEditIntro(parcours.intro || '');
        setEditOutro(parcours.outro || '');
        setEditLang(parcours.lang || 'fr');
        setIsEditModalOpen(true);
    };

    const openDeleteModal = (parcours, e) => {
        e.stopPropagation();
        setCurrentItem(parcours);
        setIsDeleteModalOpen(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!editName.trim() || !currentItem) return;
        
        const success = await onUpdateParcours(currentItem.id, editName, editIntro, editOutro, editLang);
        if (success) {
            setIsEditModalOpen(false);
        }
    };

    const handleDeleteConfirm = async () => {
        if (!currentItem) return;
        
        const success = await onDeleteParcours(currentItem.id);
        if (success) {
            setIsDeleteModalOpen(false);
        }
    };

    const handleGoBack = () => {
        onTabChange('regions');
    };
    

    return (
        <div className={styles.tabContainer}>

            {/* Bouton de retour */}
            <div className={styles.backButtonContainer}>
                <button 
                    className={styles.backButton} 
                    onClick={handleGoBack}
                >
                    <ArrowLeft /> Retour aux régions
                </button>
            </div>

            <h2 className={styles.title}>Créer un nouveau parcours</h2>

            {/* Création d'un parcours */}
            <form onSubmit={handleCreateParcours} className={styles.form}>
                <label htmlFor="parcoursName" className={styles.label}>Entrez un nouveau parcours (vous pourrez en éditer les détails dans la liste ci-dessous)</label>
                <div className={styles.formGroup}>
                    <select
                        id="parcoursLang"
                        value={parcoursLang}
                        onChange={(e) => setParcoursLang(e.target.value)}
                        className={styles.select}
                    >
                        <option value="fr">🇫🇷 FR</option>
                        <option value="en">🇬🇧 EN</option>
                        <option value="de">🇩🇪 DE</option>
                        <option value="es">🇪🇸 ES</option>
                        <option value="it">🇮🇹 IT</option>
                    </select>
                    <input
                        id="parcoursName"
                        type="text"
                        value={parcoursName}
                        onChange={(e) => setParcoursName(e.target.value)}
                        placeholder="Entrez le nom du parcours"
                        required
                        className={styles.input}
                    />
                    
                </div>
                <button type="submit" className={styles.submitButton}><ArrowRight size={16}/>Créer Parcours</button>
            </form>

            <hr className={styles.hr} />

            {/* Liste des parcours */}
            <h3 className={styles.parcoursListTitle}>
                {`Parcours disponibles pour ${village.nom}`}
            </h3>
            {parcours.length > 0 ? (
                <ul className={styles.parcoursList}>
                    {parcours.map((parcours) => (
                        <div className={styles.parcoursListRow}>
                            <div className={styles.active}>
                                <label>
                                    <label className={styles.switch}>
                                        <input 
                                            type="checkbox" 
                                            checked={!!parcours.active}
                                            onChange={() => onToggleParcoursActive(parcours.id, parcours.active ? 0 : 1)}
                                        />
                                        <span className={styles.slider}></span>
                                    </label>
                                </label>
                            </div>
                            <li key={parcours.id} className={styles.parcoursListItem} onClick={() => handleParcoursClick(parcours)}>
                                <strong className={styles.listItemStrong}><Flag lang={parcours.lang} /> - {parcours.nom}</strong>
                                <button className={styles.listItemLink}>Sélectionner</button>
                            </li>
                            <div className={styles.modButtons}>
                                <button className={styles.editButton} onClick={(e) => openEditModal(parcours, e)}>
                                    <Pencil />
                                </button>
                                <hr className={styles.hr} />
                                <button className={styles.deleteButton} onClick={(e) => openDeleteModal(parcours, e)}>
                                    <Trash2 />
                                </button>
                            </div>
                        </div>
                    ))}
                </ul>
            ) : (
                <p>Aucun parcours disponible pour ce village.</p>
            )}

            {/* Modale pour modifier un parcours */}
            <Modal 
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                title="Modifier le parcours"
            >
                <form onSubmit={handleEditSubmit}>
                    <div className={styles.formControl}>
                        <label htmlFor="editParcoursName" className={styles.label}>Nom du parcours</label>
                        <input
                            id="editParcoursName"
                            type="text"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                            className={styles.input}
                            required
                        />
                    </div>
                    <div className={styles.formControl}>
                        <label htmlFor="editLang" className={styles.label}>Langue</label>
                        <select
                            id="editLang"
                            value={editLang}
                            onChange={(e) => setEditLang(e.target.value)}
                            className={styles.select}
                        >
                            <option value="fr">🇫🇷 Français</option>
                            <option value="en">🇬🇧 Anglais</option>
                            <option value="de">🇩🇪 Allemand</option>
                            <option value="es">🇪🇸 Espagnol</option>
                            <option value="it">🇮🇹 Italien</option>
                        </select>
                    </div>
                    <div className={styles.formControl}>
                        <label htmlFor="editIntro" className={styles.label}>Introduction</label>
                        <RichTextEditor 
                            value={editIntro} 
                            onChange={({ markdown }) => setEditIntro(markdown)} 
                            placeholder="Introduction du parcours…" 
                        />
                    </div>
                    <div className={styles.formControl}>
                        <label htmlFor="editOutro" className={styles.label}>Conclusion</label>
                        <RichTextEditor 
                            value={editOutro} 
                            onChange={({ markdown }) => setEditOutro(markdown)} 
                            placeholder="Conclusion du parcours…" 
                        />
                    </div>
                    <div className={styles.buttonContainer}>
                        <button 
                            type="button" 
                            className={styles.cancelButton}
                            onClick={() => setIsEditModalOpen(false)}
                        >
                            Annuler
                        </button>
                        <button 
                            type="submit" 
                            className={styles.submitButton}
                        >
                            Enregistrer
                        </button>
                    </div>
                </form>
            </Modal>

            {/* Modal pour supprimer un parcours */}
            <Modal 
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                title="Supprimer le parcours"
            >
                <p className={styles.confirmText}>
                    Êtes-vous sûr de vouloir supprimer le parcours "{currentItem?.nom}" et toutes les questions correspondantes ?
                </p>
                <div className={styles.buttonContainer}>
                    <button 
                        type="button" 
                        className={styles.neutralButton}
                        onClick={() => setIsDeleteModalOpen(false)}
                    >
                        Annuler
                    </button>
                    <button 
                        type="button" 
                        className={styles.dangerButton}
                        onClick={handleDeleteConfirm}
                    >
                        Supprimer
                    </button>
                </div>
            </Modal>
        </div>
    );
}

export default VillageTab;
